export default "./dist/stdassets/images/icons/initial-center.png";